<section
  (window:resize)="onResize($event)"
  class="blog-swiper"
  [ngClass]="customClassName && 'page-' + customClassName"
>
  <div class="topic">
    <!-- START: custom header -->
    <ng-container *ngIf="customHeader; else defaultHeader">
      <div *ngIf="customHeader.headingTH" class="title" [innerHTML]="displayCustomText(customHeader, 'heading')"></div>
      <div *ngIf="customHeader.detailTH" class="description" [innerHTML]="displayCustomText(customHeader, 'detail')">
      </div>
    </ng-container>
    <!-- START: default header -->
    <ng-template #defaultHeader>
      <div class="title desktop" [innerHTML]="headingText()"></div>
      <div class="description" [innerHTML]="detailText()"> </div>
    </ng-template>
  </div>

  <div class="box">
    <div class="box__btn-container desktop prev">
      <button (click)="actionTransformPreviousSlide()" [disabled]="disabledPrevActionClick" aria-label="previous-slide"
        ><i class="fas fa-arrow-left"></i
      ></button>
    </div>

    <div class="box__content-container">
      <div class="box__content" [style.transform]="'translateX(' + transportPercentNo + 'px)'">
        <ng-container *ngFor="let blog of blogs; let index = index">
          <a [href]="blog.link" target="_blank" rel="noopener noreferrer" class="link-wrapper">
            <div class="box__item">
              <ng-container>
                <div class="box__video">
                  <picture *ngIf="blog.coverUrlJpg">
                    <source [srcset]="blog.coverUrlWebp" type="image/webp" />
                    <source [srcset]="blog.coverUrlJpg" type="image/jpeg" />
                    <img
                      [src]="blog.coverUrlJpg"
                      width="300"
                      height="auto"
                      loading="lazy"
                      class="img-cover"
                      [alt]="blog.imageAlt"
                      [title]="blog.imageTitle"
                    />
                  </picture>

                  <div *ngIf="!blog.coverUrlJpg" class="img-white"> </div>

                  <!-- <div class="sub-title">{{ item.subtitle | translate }}</div> -->
                  <div class="title" [innerText]="blog.heading"></div>
                  <a [href]="blog.link" target="_blank" rel="noopener noreferrer" class="read-more">
                    <span>{{ readMore() }}</span>
                    <i class="fas fa-angle-right"></i>
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="!blog.coverUrlWebp">
                <div class="img-white"> </div>
              </ng-container>
            </div>
          </a>
        </ng-container>
      </div>
    </div>

    <div class="box__btn-container desktop next">
      <button (click)="actionTransformNextSlide()" [disabled]="disabledNextActionClick" aria-label="next-slide"
        ><i class="fas fa-arrow-right"></i
      ></button>
    </div>
  </div>
</section>
